export const content = {
  title:'Estatus Tratamiento',
  nodata:'Sin Registro',
  error:'Sin registro',
  button:'Guardar',
  deleteButton:'Eliminar',
  cancelButton:'Cancelar',
  image_button:'Cambiar',
  form:{
    product_id:{
      label:'Producto + Tratamiento',
      placeholder:'Seleccione un producto',
    },
    diagnosis_id:{
      label:'Diagnóstico',
      placeholder:'Seleccione un diagnóstico',
    },
    hospital_id:{
      label:'Hospital de infusión',
      placeholder:'Seleccione un hospital',
    },
    expected_uses:{
      label:'No. de ciclos',
      placeholder:'No. de ciclos',
      helper:'Número entre 1-50'
    },
    adjuvant:{
      label:'¿Es adyuvante?',
      placeholder:'Seleccione una opción',
    },
  },
}